(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mmc-cart-drawer-script"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mmcCart) return;
    window.__mmcCart = true;

    function drawer() { return document.getElementById('CartDrawer'); }
    function drawerSectionId() {
      var d = drawer();
      var wrap = d && d.closest('.shopify-section');
      return wrap ? wrap.id.replace('shopify-section-', '') : 'cart-drawer';
    }

    /* Put a freshly rendered drawer section in place, keeping it open if it was */
    function swap(sectionHtml) {
      var current = drawer();
      if (!current || !sectionHtml) return;
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var fresh = doc.getElementById('CartDrawer');
      if (!fresh) return;
      var openClasses = ['animate', 'active', 'show', 'shadow'].filter(function (c) { return current.classList.contains(c); });
      current.innerHTML = fresh.innerHTML;
      current.className = fresh.className;
      openClasses.forEach(function (c) { current.classList.add(c); });
      var countEl = fresh.querySelector('[data-cart-items]');
      var badge = document.querySelector('[data-cart-count]');
      if (countEl && badge) {
        var n = parseInt(countEl.getAttribute('data-cart-items'), 10) || 0;
        badge.classList.toggle('hidden', n === 0);
        badge.classList.toggle('large-items', n > 99);
        badge.textContent = n === 0 || n > 99 ? '' : String(n);
      }
    }

    function openDrawer() {
      var d = drawer();
      if (!d) return;
      d.style.display = '';
      if (typeof d.open === 'function') d.open();
      else {
        d.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
    }

    function refresh(open) {
      var id = drawerSectionId();
      return fetch('/?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) { swap(data[id]); if (open) openDrawer(); });
    }

    /* Something added to the basket elsewhere: refresh the drawer and open it; on the
       basket page (no drawer) reload so the page shows the new line. */
    document.addEventListener('mam:cart:updated', function () {
      if (drawer()) refresh(true).catch(function () {});
      else if (document.querySelector('[data-mmc-basket]')) window.location.reload();
    });

    /* Forms that add to the basket without leaving the page */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('form[data-mmc-ajax-add]') : null;
      if (!form || !drawer() || !window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      var body = new FormData(form);
      body.append('sections', drawerSectionId());
      fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (data) {
          if (btn) btn.disabled = false;
          if (data.sections) swap(data.sections[drawerSectionId()]);
          else return refresh(false);
        })
        .then(openDrawer)
        .catch(function () {
          if (btn) btn.disabled = false;
          form.removeAttribute('data-mmc-ajax-add');
          form.submit();
        });
    });

    /* Quantity and remove inside the drawer */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-mmc-cart-qty], [data-mmc-cart-remove]') : null;
      if (!btn) return;
      var line = btn.closest('[data-mmc-cart-line]');
      var cartEl = btn.closest('[data-mmc-cart]');
      if (!line || !cartEl) return;
      e.preventDefault();
      var qty = parseInt(line.getAttribute('data-quantity'), 10) || 0;
      var next = btn.hasAttribute('data-mmc-cart-remove') ? 0 : Math.max(0, qty + parseInt(btn.getAttribute('data-mmc-cart-qty'), 10));
      var id = drawerSectionId();
      cartEl.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.getAttribute('data-mmc-cart-line'), quantity: next, sections: [id], sections_url: window.location.pathname }),
        credentials: 'same-origin'
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not update the basket');
          swap(res.data.sections && res.data.sections[id]);
        })
        .catch(function (err) {
          cartEl.classList.remove('is-busy');
          var msg = line.querySelector('[data-mmc-cart-error]');
          if (msg) { msg.textContent = err.message; msg.hidden = false; }
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mmc-cw-scope"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mmcCwLine) return;
    window.__mmcCwLine = true;
    var queued = false;
    function tick() {
      queued = false;
      var mid = window.innerHeight * 0.62;
      document.querySelectorAll('.mmc-cwseg').forEach(function (seg) {
        var r = seg.getBoundingClientRect();
        var p = (mid - r.top) / Math.max(1, r.height);
        seg.style.setProperty('--p', Math.max(0, Math.min(1, p)).toFixed(3));
      });
      document.querySelectorAll('.mmc-cwmark').forEach(function (mark) {
        mark.classList.toggle('is-on', mark.getBoundingClientRect().top < mid);
      });
    }
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(tick);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', schedule);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
    else schedule();
    setTimeout(schedule, 400);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mmc-legal"] && !Shopify.designMode) return;
  try {
    /* Contents: fold away on phones; highlight the heading being read; links glide to
     their heading with room for the sticky menu. */
  (function () {
    if (window.__mmcLegal) return;
    window.__mmcLegal = true;
    function wire() {
      var root = document.querySelector('[data-mmc-legal]');
      if (!root) return;
      var toc = root.querySelector('.mmc-art__toc');
      if (!toc) return;
      if (window.matchMedia('(max-width: 900px)').matches) toc.removeAttribute('open');
      var links = Array.prototype.slice.call(toc.querySelectorAll('a'));
      var heads = links.map(function (a) { return document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1))); });
      var queued = false;
      function spy() {
        queued = false;
        var line = window.innerHeight * 0.3;
        var cur = 0;
        heads.forEach(function (h, i) { if (h && h.getBoundingClientRect().top < line) cur = i; });
        links.forEach(function (a, i) { a.classList.toggle('is-on', i === cur); });
      }
      window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(spy); } }, { passive: true });
      spy();
      toc.addEventListener('click', function (e) {
        var a = e.target.closest('a[href^="#"]');
        if (!a) return;
        var t = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
        if (!t) return;
        e.preventDefault();
        var header = document.querySelector('.mam-header');
        var y = t.getBoundingClientRect().top + window.scrollY - ((header ? header.getBoundingClientRect().height : 0) + 24);
        if (window.__lenis && window.__lenis.scrollTo) window.__lenis.scrollTo(y, { duration: 1.1 });
        else window.scrollTo({ top: y, behavior: 'smooth' });
        history.replaceState(null, '', a.getAttribute('href'));
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
    else wire();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mmc-pair-add"] && !Shopify.designMode) return;
  try {
    /* One /cart/add.js call for the pair, then `mam:cart:updated` so the basket drawer refreshes and
     opens (snippets/mmc-cart-drawer-script). Handled at document level, so it works wherever the
     button is. If the add fails (e.g. one sold out meanwhile) the button follows its link, or its
     data-fallback-url, instead. */
  (function () {
    if (window.__mmcPairAdd) return;
    window.__mmcPairAdd = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-mmc-pair-add]') : null;
      if (!btn || !window.fetch) return;
      e.preventDefault();
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.getAttribute('aria-busy') === 'true') return;
      var label = btn.querySelector('[data-mmc-pair-label]');
      var original = label ? label.textContent : '';
      var items = btn.getAttribute('data-mmc-pair-add').split(',').map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
      btn.setAttribute('aria-busy', 'true');
      if (label) label.textContent = btn.getAttribute('data-adding-label') || original;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
        credentials: 'same-origin'
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          btn.removeAttribute('aria-busy');
          if (label) label.textContent = original;
          document.dispatchEvent(new CustomEvent('shopify:cart:updated'));
          document.dispatchEvent(new CustomEvent('mam:cart:updated'));
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          if (label) label.textContent = original;
          var href = btn.getAttribute('href') || btn.getAttribute('data-fallback-url');
          if (href && href !== '#') window.location.href = href;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mmc-product-card"] && !Shopify.designMode) return;
  try {
    /* Live review total for the hero's "Based on … reviews" line. The yotpo.reviews_count metafield
     can lag behind Yotpo, so ask Yotpo directly (public widget API, the same data the reviews widget
     shows) using the app key from the Yotpo loader already on the page. Shows the line with the live
     count, hides it when there are none, and leaves the server-rendered line alone if Yotpo can't be
     reached. Remembered for the visit so repeat views don't flicker. */
  (function () {
    if (window.__mmcYotpoCount) return;
    window.__mmcYotpoCount = true;

    function appKey() {
      var el = document.querySelector('script[src*="cdn-widgetsrepository.yotpo.com/v1/loader/"]');
      var m = el && el.getAttribute('src').match(/\/loader\/([^/?#]+)/);
      return m ? m[1] : null;
    }
    function apply(row, total) {
      var n = row.querySelector('.mmc-pcol__reviews-n');
      if (total > 0) {
        if (n) n.textContent = total === 1 ? '1 review' : total + ' reviews';
        row.hidden = false;
      } else {
        row.hidden = true;
      }
    }
    function totalFrom(data) {
      var b = data && data.response && data.response.bottomline;
      if (!b) return null;
      var t = b.total_review != null ? b.total_review : b.total_reviews;
      t = parseInt(t, 10);
      return isNaN(t) ? null : t;
    }
    function fetchTotal(key, pid) {
      var urls = [
        'https://api-cdn.yotpo.com/v1/widget/' + key + '/products/' + pid + '/reviews.json?per_page=1&page=1',
        'https://api.yotpo.com/products/' + key + '/' + pid + '/bottomline'
      ];
      function attempt(i) {
        if (i >= urls.length) return Promise.reject(new Error('no Yotpo total'));
        return fetch(urls[i], { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (data) { var t = totalFrom(data); if (t == null) throw new Error('no total'); return t; })
          .catch(function () { return attempt(i + 1); });
      }
      return attempt(0);
    }
    function run() {
      var rows = document.querySelectorAll('[data-mmc-yotpo-count]');
      if (!rows.length || !window.fetch) return;
      var key = appKey();
      if (!key) return;
      Array.prototype.forEach.call(rows, function (row) {
        var pid = row.getAttribute('data-mmc-yotpo-count');
        if (!pid) return;
        var cacheKey = 'mmcYotpoTotal:' + pid;
        try {
          var cached = sessionStorage.getItem(cacheKey);
          if (cached !== null) apply(row, parseInt(cached, 10));
        } catch (e) {}
        fetchTotal(key, pid).then(function (total) {
          apply(row, total);
          try { sessionStorage.setItem(cacheKey, String(total)); } catch (e) {}
        }).catch(function () {});
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mmc-variant-pill"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mmcVariantPill) return;
    window.__mmcVariantPill = true;

    function sync(variant) {
      var btns = document.querySelectorAll('[data-mam-variant-btn]');
      for (var i = 0; i < btns.length; i++) {
        btns[i].setAttribute('aria-selected', btns[i].getAttribute('data-mam-variant-btn') === variant ? 'true' : 'false');
      }
      /* Fixed ids (#bioactives, #adaptive-benefits) belong to the copy that's showing */
      var copies = document.querySelectorAll('[data-mam-variant-show][data-mam-variant-id]');
      for (var c = 0; c < copies.length; c++) {
        var base = copies[c].getAttribute('data-mam-variant-id');
        var show = copies[c].getAttribute('data-mam-variant-show');
        copies[c].id = show === variant ? base : base + '-' + show;
      }
    }

    function apply(variant) {
      if (variant !== 'bloom' && variant !== 'shade') return;
      if (document.body.getAttribute('data-mam-variant') === variant) return;
      document.body.setAttribute('data-mam-variant', variant);
      try { window.localStorage.setItem('mam:home-variant', variant); } catch (e) {}
      sync(variant);
      /* Sliders and pinned sections in the copy that just appeared measure themselves on resize */
      window.dispatchEvent(new Event('resize'));
      document.dispatchEvent(new CustomEvent('mam:variant-change', { detail: { variant: variant } }));
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.mmc-vpill [data-mam-variant-btn]') : null;
      if (btn) apply(btn.getAttribute('data-mam-variant-btn'));
    });

    function init() { sync(document.body.getAttribute('data-mam-variant') || 'bloom'); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
